import { useMemo } from 'react';
import { useContact } from '../Contact';

export const useNotificationsEnabled = () => {
  const { contactInfo, registrationStatus } = useContact();

  return useMemo(
    () => ({
      enabled:
        registrationStatus.isApproved &&
        // TODO: Remove this line to enable the featured notifications
        Boolean(contactInfo?.portalNotificationSettings) &&
        Boolean(contactInfo?.betaParticipantStatus),
    }),
    [contactInfo, registrationStatus],
  );
};
